import { handleActions } from 'redux-actions';
import { PackagePickerStoreSlice } from './types';
import { initPackagePicker } from './actions';
import { reduxKey } from './constants';
import { PapiDacheckoutCorePackages } from '@wix/da-papi-types';

const reducers = handleActions<PackagePickerStoreSlice, any>(
  {
    [`${initPackagePicker}`]: (
      state,
      action: ReturnType<typeof initPackagePicker>
    ) => {
      const { pickerMode, data } = action.payload;
      return {
        ...state,
        sale: data.sale as any, // missing heroImageAlt
        pickerMode,
        pickerStep: 'picking',
        packageProducts: data.packageProducts,
        packageBenefits: (data.packageBenefits ||
          []) as PapiDacheckoutCorePackages['packageBenefits'],
        packageConfig: (data.packageConfig ||
          []) as PapiDacheckoutCorePackages['packageConfig'],
        currentCoreSuscriptionV3: data.currentCoreSubscriptionV3,
        giftUser: data.giftUser,
        faqs: data.faqs,
      };
    },
  },
  {
    // Gibberish values
    pickerMode: 'buy',
    pickerStep: 'picking',
  }
);

export default {
  [reduxKey]: reducers,
};
